export function isValidEmail({ email }: { email: string }): boolean {
    return !!email && email.length > 3 && email.includes('@') && email.includes('.');
}

export function isChannelNameValid({ channelName }: { channelName: string }): boolean {
    return channelName.length > 0;
}
